import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useState2RM from '../../hooks/useState2ReduxMock';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { useAppDispatch, useActions, MailActions } from '@web-common/state/createStore';
import classnames from 'classnames';
import { getTreeStatesByAccount, isMainAccount, mailConfigStateIsMerge, mailLogicStateIsMerge, treeDFS, folderIdIsAllFolder, folderIdIsAllTopFolder, folderIdIsAllRedFlagFolder, folderIdIsAllUnreadFolder, isFollowFolder, } from '../../util';
import { apiHolder, apis } from 'api';
import MailMultOperation from './MailMultOperation';
import { FLOLDER, LIST_MODEL } from '../../common/constant';
import FilterTabPlus from './filterTabPlus';
import FilterTabEdmLong from './filterTabPlusEdmLong';
const trackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const FilterTab = (props) => {
    const dispatch = useAppDispatch();
    const reducer = useActions(MailActions);
    const [mailTreeStateMap] = useState2RM('mailTreeStateMap');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [, setSearchSelected] = useState2RM('', 'doUpdateSearchListStateTab');
    const [, setSelected] = useState2RM('', 'doUpdateMailListStateTab');
    const [selectedKeys] = useState2RM('selectedKeys');
    const [configMailLayout] = useState2RM('configMailLayout', 'doUpdateConfigMailLayout');
    const isLong = useMemo(() => configMailLayout === '2' || (process.env.BUILD_ISEDM && configMailLayout === '3'), [configMailLayout]);
    const [AllFolderData] = useState2RM('AllFolderData');
    const [unRead, setUnRead] = useState(0);
    const [clickCancel, setClickCancel] = useState(false);
    const isMerge = () => mailLogicStateIsMerge(selectedKeys.id, selectedKeys.accountId, isSearching);
    const [listModel] = useState2RM('defaultMailListSelectedModel');
    const taskMailBoxTab = useMemo(() => selectedKeys.id == FLOLDER.TASK && !isSearching && isMainAccount(selectedKeys.accountId), [selectedKeys, isSearching]);
    const deferBoxTab = useMemo(() => selectedKeys.id == FLOLDER.DEFER && !isSearching && isMainAccount(selectedKeys.accountId), [selectedKeys, isSearching]);
    const isMailTagTab = useMemo(() => selectedKeys.id === FLOLDER.TAG && !isSearching, [selectedKeys.id, isSearching]);
    const filterShowFlag = useMemo(() => {
        if (selectedKeys.id === FLOLDER.TAG) {
            return false;
        }
        if (mailConfigStateIsMerge()) {
            return (selectedKeys && selectedKeys.id !== FLOLDER.SENT && selectedKeys.id !== FLOLDER.REDFLAG && selectedKeys.id !== FLOLDER.TAG && selectedKeys.id !== FLOLDER.DRAFT);
        }
        else {
            if (folderIdIsAllRedFlagFolder(selectedKeys.id) || folderIdIsAllUnreadFolder(selectedKeys.id)) {
                return false;
            }
            if (folderIdIsAllFolder(selectedKeys.id)) {
                return true;
            }
            return selectedKeys && selectedKeys.id;
        }
    }, [isSearching, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, taskMailBoxTab, deferBoxTab]);
    const clickItem = useCallback(item => {
        if (filterShowFlag) {
            clickTab(item);
        }
        else if (taskMailBoxTab) {
            clickTaskTab(item);
        }
        else if (deferBoxTab) {
            clickDeferTab(item);
        }
    }, [filterShowFlag, taskMailBoxTab, deferBoxTab, isSearching]);
    const handleCancel = () => {
        setClickCancel(true);
        setTimeout(() => {
            setClickCancel(false);
        }, 1000);
    };
    useEffect(() => {
        var _a;
        if (folderIdIsAllFolder(selectedKeys.id)) {
            if (AllFolderData && AllFolderData.length) {
                const map = {};
                treeDFS(AllFolderData, (item) => {
                    map[item.entry.mailBoxId] = item;
                });
                setUnread(map);
            }
        }
        else if ((filterShowFlag || isFollowFolder(selectedKeys.id)) && !isSearching) {
            const treeList = ((_a = getTreeStatesByAccount(mailTreeStateMap, selectedKeys.accountId)) === null || _a === void 0 ? void 0 : _a.mailFolderTreeList) || [];
            if (treeList && treeList.length) {
                const map = {};
                treeDFS(treeList, (item) => {
                    map[item.entry.mailBoxId] = item;
                });
                setUnread(map);
            }
        }
    }, [selectedKeys, mailTreeStateMap, isSearching, filterShowFlag, AllFolderData]);
    const refreshEmailList = (param = {}) => {
        const { noCache = false, showLoading = true } = param;
        dispatch(Thunks.refreshMailList({
            noCache,
            showLoading,
        }));
    };
    const RefrefreshEmailList = useRef(refreshEmailList);
    RefrefreshEmailList.current = refreshEmailList;
    const handleAllRead = () => {
        dispatch(reducer.updateAllReadLoading({
            accountId: selectedKeys.accountId,
            folderId: selectedKeys.id,
            loading: true,
        }));
        return dispatch(Thunks.doActiveFolderAllRead({
            folderId: selectedKeys.id,
            isThread: isMerge(),
            accountId: selectedKeys.accountId,
        }))
            .unwrap()
            .finally(() => {
            dispatch(reducer.updateAllReadLoading({
                accountId: selectedKeys.accountId,
                folderId: selectedKeys.id,
                loading: false,
            }));
        });
    };
    const setUnread = (argMap) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (isFollowFolder(selectedKeys.id)) {
            if (folderIdIsAllTopFolder(selectedKeys.id)) {
                const unread = ((_b = (_a = argMap[selectedKeys.id]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.mailBoxTotal) || 0;
                setUnRead(unread);
                dispatch(MailActions.doUpdataCurrentFolderUnReadCount(unread));
            }
            else {
                const curTreeMap = ((_c = getTreeStatesByAccount(mailTreeStateMap, selectedKeys.accountId)) === null || _c === void 0 ? void 0 : _c.MailFolderTreeMap) || {};
                const map = argMap || curTreeMap;
                let unread = 0;
                if (isMerge()) {
                    unread = (_e = (_d = map[selectedKeys.id]) === null || _d === void 0 ? void 0 : _d.entry) === null || _e === void 0 ? void 0 : _e.threadMailBoxTotal;
                }
                else {
                    unread = (_g = (_f = map[selectedKeys.id]) === null || _f === void 0 ? void 0 : _f.entry) === null || _g === void 0 ? void 0 : _g.mailBoxTotal;
                }
                setUnRead(unread);
                dispatch(MailActions.doUpdataCurrentFolderUnReadCount(unread));
            }
            return;
        }
        if (folderIdIsAllTopFolder(selectedKeys.id)) {
            const unread = ((_j = (_h = argMap[selectedKeys.id]) === null || _h === void 0 ? void 0 : _h.entry) === null || _j === void 0 ? void 0 : _j.mailBoxCurrentUnread) || 0;
            setUnRead(unread);
            dispatch(MailActions.doUpdataCurrentFolderUnReadCount(unread));
        }
        else {
            const curTreeMap = ((_k = getTreeStatesByAccount(mailTreeStateMap, selectedKeys.accountId)) === null || _k === void 0 ? void 0 : _k.MailFolderTreeMap) || {};
            const map = argMap || curTreeMap;
            let unread = 0;
            if (isMerge()) {
                unread = (_m = (_l = map[selectedKeys.id]) === null || _l === void 0 ? void 0 : _l.entry) === null || _m === void 0 ? void 0 : _m.threadMailBoxCurrentUnread;
            }
            else {
                unread = (_p = (_o = map[selectedKeys.id]) === null || _o === void 0 ? void 0 : _o.entry) === null || _p === void 0 ? void 0 : _p.mailBoxCurrentUnread;
            }
            setUnRead(unread);
            dispatch(MailActions.doUpdataCurrentFolderUnReadCount(unread));
        }
    };
    const clickTab = async (item) => {
        if (isSearching) {
            setSearchSelected(item.type);
            refreshEmailList({});
        }
        else {
            setSelected(item.type);
            try {
                const folder_type = selectedKeys.id === 1 ? '系统收件箱' : selectedKeys.id >= 100 ? '自定义文件名' : '其他文件夹';
                const display_mode = isMerge() ? '聚合' : '普通';
                const classification = item.type === 'ALL' ? '全部邮件' : item.title;
                trackerApi.track('pc_intelligent_display_sort_pv', {
                    folder_type,
                    classification,
                    display_mode,
                });
            }
            catch (error) { }
        }
    };
    const clickTaskTab = (item) => {
        setSelected(item.type);
        try {
            trackerApi.track('pcMail_switchTab_taskMailList_mailListPage', {
                tabName: item.title,
            });
        }
        catch (error) { }
    };
    const clickDeferTab = (item) => {
        setSelected(item.type);
    };
    return (React.createElement(React.Fragment, null, React.createElement(React.Fragment, null, (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) && isLong ? (React.createElement(FilterTabEdmLong, { hiddenFilter: !filterShowFlag, unread: unRead, clickItem: clickItem, handleAllRead: handleAllRead, isMerge: isMerge, operElement: React.createElement("div", { style: { height: '100%' }, className: classnames(['m-list-operation-new'], {
                ['m-list-operation1-new']: true,
                ['m-list-operation100-new']: listModel == LIST_MODEL.MULTIPLE,
                ['m-list-cancel-new']: clickCancel,
            }) },
            React.createElement(MailMultOperation, { cancelFn: handleCancel })) })) : (React.createElement(FilterTabPlus, { hiddenFilter: !filterShowFlag, unread: unRead, clickItem: clickItem, handleAllRead: handleAllRead, isMerge: isMerge, operElement: React.createElement("div", { style: { height: '100%' }, className: classnames(['m-list-operation-new'], {
                ['m-list-operation1-new']: true,
                ['m-list-operation100-new']: listModel == LIST_MODEL.MULTIPLE,
                ['m-list-cancel-new']: clickCancel,
            }) },
            React.createElement(MailMultOperation, { cancelFn: handleCancel })) })))));
};
export default FilterTab;
